import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../../../../../utils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useCallback } from 'react';
import { useEffect } from 'react';
import debounce from 'lodash.debounce';

function TransactionsAnalysis() {
    const [checkedValue, setCheckedValue] = useState({ transaction_analysis: '' });
    const [updatedTask, setUpdatedTask] = useState(null);
    const uid = localStorage.getItem("user_id");

    const fetchData = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);

            const response = await axios.post(`${API.BASE_URL}${API.ENDPOINTS.get_growth_transactions}`, formDataToSend, {
                headers: {
                    Authorization: `${API.AUTHORIZATION_TOKEN}`,
                },
            });

            if (response.data.status === "success") {
                setCheckedValue(response.data.data || { transaction_analysis: '' });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Fetch meeting types error', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const debouncedUpdateTask = useCallback(
        debounce(async (task) => {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);
            formDataToSend.append('analysis', task.value || '');

            try {
                const response = await axios.post(
                    `${API.BASE_URL}${API.ENDPOINTS.add_update_transactions_analysis}`,
                    formDataToSend,
                    {
                        headers: {
                            Authorization: `${API.AUTHORIZATION_TOKEN}`,
                        },
                    }
                );

                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    fetchData();
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error("An error occurred while updating data.");
            }
        }, 1000),
        [uid]
    );

    useEffect(() => {
        if (updatedTask) {
            debouncedUpdateTask(updatedTask);
        }
    }, [updatedTask, debouncedUpdateTask]);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        // Update the state based on the checkbox value
        setCheckedValue({
            people_analysis: checked ? value : ''
        });

        // Set the updated task to trigger debounced update
        setUpdatedTask({
            value: checked ? value : ''
        });
    };

    return (
        <div className="col-sm-12">
            <div className="card mt-4">
                <div className="card-header">
                    <div className='justify-content-between d-flex '>
                        <div className="">
                            <h5>Transactions Analysis</h5>
                        </div>
                        <div >
                            <Link className='backto-ondriver' to="/growthframeworks/founderdriver">Back to the Founder OS Drivers of Growth</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card-body">
                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.transaction_analysis === 'Enterprise' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Enterprise"
                                    checked={checkedValue.transaction_analysis === 'Enterprise'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Enterprise</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • A strong capital position enables accelerated growth and optimized customer and shareholder value through mergers and acquisitions.
                                    </p>
                                    <p className="textnots-text">
                                        • Highly successful inorganic growth plays a fundamental role in strategy and business performance.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.transaction_analysis === 'Corporation' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Corporation"
                                    checked={checkedValue.transaction_analysis === 'Corporation'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Corporation</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Access to greater capital and resources enables strategic alliances and acquisitions. These drive expansion, efficiency and profitability.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.transaction_analysis === 'Startup' ? '#d3f9d8' : 'white' }}
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Startup"
                                    checked={checkedValue.transaction_analysis === 'Startup'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Startup</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Partnerships and alliances (e.g. distribution agreements, outsourcing agreements, commercial partnerships, joint ventures) are the primary sources for inorganic growth.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TransactionsAnalysis;
